import React, { Component } from "react";
import { connect } from "react-redux";
import { Progress, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import isEqual from "lodash.isequal";
import "assets/stylesheets/FieldCard.scss";

class FieldCard extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  isActive = () => {
    const { recommendation: rec, selectedFieldOfStudy } = this.props;
    return isEqual(rec, selectedFieldOfStudy);
  };

  handleClickCard = () => {
    const { recommendation: rec } = this.props;
    this.props.dispatch({
      type: "SELECT_FIELD_OF_STUDY",
      data: { selectedFieldOfStudy: rec },
    });
  };

  renderCheckIcon = () => {
    if (this.isActive()) {
      return (
        <FontAwesomeIcon icon={faCheckCircle} className="card__check-icon" />
      );
    } else {
      return null;
    }
  };

  renderButton = () => {
    const { recommendation: rec } = this.props;
    return (
      <Button
        ref={this.ref}
        className={"card__button" + (this.isActive() ? "--active" : "")}
        onClick={this.handleClickCard}
        aria-label={`View institutions that have ${rec.desc}`}
      >
        View institutions
      </Button>
    );
  };

  getNumberClass = (prob) => {
    if (prob < 0.15) {
      return "fos-card__number--small";
    } else {
      return "fos-card__number--large";
    }
  };

  renderFosCard = () => {
    const { recommendation: rec, sum } = this.props;
    const percent = (rec.probability / sum) * 100;
    return (
      <div
        className={
          "fos-card__container " +
          (this.isActive() ? "card__container--selected" : "")
        }
        key={rec.desc}
        tabIndex={0}
        aria-label={`${parseInt(percent)}% - ${rec.desc}`}
      >
        <Progress
          strokeLinecap="square"
          strokeWidth={30}
          strokeColor="#15506f"
          showInfo={false}
          className="fos-card__progress"
          percent={percent}
        ></Progress>
        {this.renderCheckIcon()}
        <div className={this.getNumberClass(rec.probability)}>
          {percent.toFixed(0) + "%"}
        </div>
        <div className="fos-card__bottom">
          <img className="card__image" src={`images/${rec.id}.png`} alt="" />
          <h2 className="card__title" onClick={this.handleClickCard}>
            {rec.desc}
          </h2>
          <div className="fos-card__bottom">{this.renderButton()}</div>
        </div>
      </div>
    );
  };

  renderRelatedCard = () => {
    const { recommendation: rec } = this.props;
    return (
      <div
        className={
          "related-card__container " +
          (this.isActive() ? "card__container--selected" : "")
        }
        key={rec.id}
        tabIndex={0}
        aria-label={`${rec.desc}`}
      >
        {this.renderCheckIcon()}

        <div className="related-card__top">
          <img
            className="related-card__image"
            src={`images/other/${rec.id}.png`}
            alt=""
          />
          <h2 className="related-card__title" onClick={this.handleClickCard}>
            {rec.desc}
          </h2>
        </div>
        <div className="related-card__bottom">{this.renderButton()}</div>
      </div>
    );
  };

  render() {
    const { fos } = this.props;
    return fos ? this.renderFosCard() : this.renderRelatedCard();
  }
}

const mapStateToProps = (store) => {
  const { selectedFieldOfStudy } = store.selectFieldOfStudyReducer;
  return { selectedFieldOfStudy };
};

export default connect(mapStateToProps)(FieldCard);
